import React from "react";
import moment from 'moment';

import DatePicker from 'react-date-picker';


class DatePickInputWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            value: null,
            needsToChange: true
        }
    }

    // Event handlers
    toggleDatePicker(e) {
        e && e.preventDefault && e.preventDefault(); // jshint ignore:line
        if (this.state.needsToChange) {
            this.setState({
                isOpen: true
            });
        } else {
            this.setState({needsToChange: true});
        }
    }

    onValueChange (date) {
        this.props.onValueChange((!this.props.isRequired && date === null) ? null : moment(date).format('DD.MM.YYYY'));

        this.setState({
            value: date,
            isOpen: false,
            needsToChange: false
        });
    }

    clearValue (e) {
        e && e.preventDefault(); // jshint ignore:line

        this.onValueChange(null);
    }

    // Rendering
    render () {
        const className = 'dropdown clearfix' + (this.state.isOpen ? ' open' : '');
        let clearLink;

        if (!this.props.isRequired) {
            clearLink = (<a href="" onClick={this.clearValue} className="clearDate">Clear</a>);
        }

        return (
            <div className={className}>
                <div ref="datepickerInput" className="clearfix input-group" onClick={this.toggleDatePicker.bind(this)}>
                    <input disabled={this.props.disabled} type="text" className={this.props.className} placeholder={this.props.placeholder} value={this.props.value} />
                </div>

                <div className="dropdown-menu dropdown-menu--date-picker dropdown-menu--input--right">
                    <DatePicker  weekStartDay="1" minDate={this.props.minDate} maxDate={this.props.maxDate} date={this.state.value || new Date()} onChange={this.onValueChange.bind(this)} />
                    {clearLink}
                </div>

                {/*<div className="date-picker--overlay" onClick={this.toggleDatePicker.bind(this)}></div>*/}
            </div>
        );
    }
}

DatePickInputWrapper.propTypes = {
    onValueChange: React.PropTypes.func.isRequired
};

export default DatePickInputWrapper;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/utils/DatePickInputWrapper.jsx
 **/